/*
 * @Author: yuanxing(01407381)
 * @Date: 2023-04-06 10:36:23
 * @LastEditors: yuanxing(01407381)
 * @LastEditTime: 2023-05-19 15:42:56
 * @FilePath: \ibu-owt-core-frontend\site\country\my\index.js
 * @Description:
 */
// import Consign from '../sg/consign/index.vue'
// import Product from '../sg/product/index.vue'
// import Contact from '../sg/contact/index.vue'
// import Dept from '../sg/dept/index.vue'
// import Index from './index/index.vue'
// import Invoice from './invoice/index.vue'
// import Careers from './careers/index.vue'

// export const pages = {
//   index: Index, // 首页
//   consign: Consign, // 服务支持 寄件流程指引
//   product: Product, // 物流服务 物流产品详情
//   contact: Contact, // 联系我们
//   dept: Dept, // 服务网点
//   invoice: Invoice, // 发票申请
//   careers: Careers, // 人才招聘
// }


export const pages = {
  index: () => import('./index/index.vue'), // 首页
  consign: () => import('../sg/consign/index.vue'), // 服务支持 寄件流程指引
  product: () => import('../sg/product/index.vue'), // 物流服务 物流产品详情
  productDetail: () => import('./product-detail/index.vue'), // 韩国站产品详情
  contact: () => import('../sg/contact/index.vue'), // 联系我们
  dept: () => import('../sg/dept/index.vue'), // 服务网点
  invoice: () => import('./invoice/index.vue'), // 发票申请
  careers: () => import('./careers/index.vue'), // 人才招聘
  cooperation:() => import('./cooperation/index.vue'), // 合作咨询
}